import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDescargablesContext } from "../../../context/DescargablesContext"
import useForm from "../../../hooks/useForm"
import { DescargableI } from "../../../models/descargables"
import { DescargableFilesI, addDescargable, updateDescargable } from "../../../services/descargable"
import { isNewRegister } from "../../../utils/strings"

const initialStateValues = {
  id: '',
  titulo: '',
  descripcion_breve: '',
  img_thumb: '',
  descargar_pdf: '',
  descargar_ppt: '',
  categorias: '',
  restringido: false,
  path_img_thumb:"",
  path_descargar_pdf:"",
  path_descargar_ppt:"",
  sku:'',
  destacado: false,
  activo: true
}

const useDescargableAdd = ({descargable, navigation, idDescargable}: {descargable?: DescargableI, navigation?: boolean, idDescargable?: string}) => {

  const [images, setImages] = useState<DescargableFilesI>({
    imgThumb: undefined,
    uploadPDF: undefined,
  })
  const {setDescargables, descargables} = useDescargablesContext()
  const navigate = useNavigate()
  const { onChange, formData, setFormData } = useForm(descargable || initialStateValues)
  const { id } = useParams()

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault()


    try {

      if (isNewRegister(`${id}`)) {
        
        const descargableRes = await addDescargable(
          {
            ...formData,
            activo: true,
            fechaRegistro: new Date()
          },
          images
        )

        alert("Descargable añadido")
        setDescargables(prev=>[...prev,descargableRes])
        navigate('/descargable')

      } else {
        const descargableRes = await updateDescargable(
          `${id}`,
          { ...formData },
          images
        )
        alert("Descargable actualizado")
        setDescargables(prev=>prev.map(e => {

          if(e.id!==id) return e

          return {...descargableRes, id}

        }))
        navigate('/descargable')
      }

    } catch (e) {
      console.error(e)
    }

  }

  const handleSubmitSku = async (e?: React.FormEvent<HTMLFormElement>) => {

    e?.preventDefault()


    try {

      if (!formData?.id) {
        
        const descargableRes = await addDescargable(
          {
            ...formData,
            activo: true,
          },
          images
        )

        alert("Descargable añadido")
        setDescargables(prev=>[...prev,descargableRes])
        

      } else {
        const descargableRes = await updateDescargable(
          `${formData?.id}`,
          { ...formData },
          images
        )
        alert("Descargable actualizado")
        setDescargables(prev=>prev.map(e => {

          if(e.id!==formData?.id) return e

          return {...descargableRes, id:formData?.id}

        }))
        
      }

    } catch (e) {
      console.error(e)
    }

  }

  const handleDeleteRelatedDescargable = async ({sku = '', id}:{sku: string, id: string}) => {

    if(!id) return

    const descargable = descargables.find(e => e.id === id)

    const data = {
      ...descargable,
      sku,
      id
    }

    try {

      const descargableRes = await updateDescargable(
        id,
        data,
        {
          imgThumb: undefined,
          uploadPDF: undefined,
        }
      )
      alert("Descargable actualizado")

      setDescargables(prev=>prev.map(e => {

        if(e.id!==id) return e

        return {...descargableRes, id}

      }))
        
      

    } catch (e) {
      console.error(e)
    }

  }

  return {
    handleSubmit,
    handleSubmitSku,
    onChange,
    formData,
    setFormData,
    images,
    setImages,
    handleDeleteRelatedDescargable
  }

}

export default useDescargableAdd